<template>
  <div>
    <table class="custom-table responsive-table border-collapse">
      <thead class="font-normal">
        <tr class="shadow-table rounded-lg">
          <th class="checkbox">
            <base-checkbox />
          </th>
          <th>Shipping ID #</th>
          <th>Route</th>
          <th>Destination</th>
          <th>Gross Weight</th>
          <th>Total Shipping Cost</th>
          <th>Trans Date</th>
          <th>Status</th>
          <th tabindex="-1">
            <span @click="showFilterModal = true" class="cursor-pointer">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.7">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                    fill="#383F51"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                    fill="#383F51"
                  />
                </g></svg
            ></span>
          </th>
        </tr>
      </thead>
      <tbody v-if="!loading">
        <tr
          v-for="(recievable, index) in recievables"
          :key="index"
          class="shadow-table rounded-lg"
        >
          <td>
            <base-checkbox />
          </td>
          <td>{{ recievable.shippingReference }}</td>
          <td>
            {{
              recievable.shippingservice
                ? recievable.shippingservice.routeName
                : "N/A"
            }}
          </td>
          <td>
            {{
              recievable.consigneelocation.address
                ? recievable.consigneelocation.address.name
                : "N/A"
            }}
          </td>
          <!-- <td v-if="group.groupincidents">{{ group.groupincidents.length }}</td>
                <td v-else>-</td> -->
          <td>{{ recievable.grossWeight ? recievable.grossWeight : "N/A" }}</td>
          <td>
            {{
              recievable.transaction ? recievable.transaction.totalValue : "N/A"
            }}
          </td>
          <td>
            {{
              recievable.createdAt ? recievable.createdAt.split("T")[0] : "N/A"
            }}
            <span class="block w-full opacity-50">{{
              recievable.createdAt
                ? recievable.createdAt.split("T")[1].split(".")[0]
                : ""
            }}</span>
          </td>
          <td>
            <span
              :class="[
                true
                  ? statusBg(
                      recievable.deliveryStatus
                        ? recievable.deliveryStatus
                        : 'pending'
                    )
                  : null,
              ]"
              >{{
                recievable.deliveryStatus ? recievable.deliveryStatus : "N/A"
              }}</span
            >
          </td>
          <td
            tabindex="-1"
            @blur="selectedRowId = null"
            class="table__action-btn cursor-pointer relative"
          >
            <span
              class="-full flex justify-center"
              @click="selectedRowId = index"
            >
              <vertical-ellipsis />
            </span>

            <div class="actions" v-if="selectedRowId == index">
              <div
                class="cursor-pointer hover:bg-gray-100"
                @click="
                  transactionRoute(
                    recievable.transaction ? recievable.transaction.id : null
                  )
                "
              >
                <span class="icon"
                  ><img
                    alt=""
                    class="mr-1"
                    src="@/assets/images/billing/icon-eye-alt.svg"
                /></span>
                <span>View</span>
              </div>
              <div
                class="cursor-pointer hover:bg-gray-100"
                @click="
                  invoiceRoute(
                    recievable.transaction ? recievable.transaction.id : null
                  )
                "
              >
                <span class="icon"
                  ><img
                    alt=""
                    class="mr-1"
                    src="@/assets/images/billing/send_invoice.svg"
                /></span>
                <span>Send Invoice</span>
              </div>
              <div
                class="cursor-pointer hover:bg-gray-100"
                @click="collectPaymentModalFunc(recievable)"
              >
                <span class="icon"
                  ><img
                    alt=""
                    class="mr-1"
                    src="@/assets/images/billing/collectPayment.svg"
                /></span>
                <span>Collect Payment</span>
              </div>
              <div
                class="cursor-pointer hover:bg-gray-100"
                @click="sharelinkModalFunc(recievable)"
              >
                <span class="icon"
                  ><img
                    alt=""
                    class="mr-1"
                    src="@/assets/images/billing/sharepaylink.svg"
                /></span>
                <span>Share Pay Link</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <EmptyContent v-if="!recievables.length" />
    <TableheaderFilter
      :show-modal="showFilterModal"
      @close-modal="showFilterModal = false"
    />
    <CollectPayment
      :shippingId="shippingId"
      :transactionId="transactionId"
      :totalCost="totalCost"
      :show-modal="collectPaymentModal"
      @close-modal="collectPaymentModal = false"
    />
    <SharePayLink
      :paymentParams="paymentParams"
      :show-modal="shareLinkModal"
      @close-modal="shareLinkModal = false"
    />
  </div>
</template>

<script>
import TableheaderFilter from "../modals/TableheaderFilter.vue";
import CollectPayment from "../modals/CollectPayment.vue";
import SharePayLink from "../modals/SharePayLink.vue";
import EmptyContent from "../svg/EmptyContent.vue";

export default {
  props: ["recievables"],
  components: {
    TableheaderFilter,
    CollectPayment,
    SharePayLink,
    EmptyContent,
  },
  data() {
    return {
      showFilterModal: false,
      collectPaymentModal: false,
      selectedRowId: -1,
      shareLinkModal: false,
      totalCost: 0,
      transactionId: null,
      shippingId: "",
      paylink: "",
      email: "",
      payAmount: "",
    };
  },
  computed: {
    paymentParams() {
      return {
        paylink: this.paylink,
        email: this.email,
        payAmount: this.payAmount,
      };
    },
  },
  methods: {
    collectPaymentModalFunc(val) {
      this.totalCost = val?.transaction?.totalValue;
      this.transactionId = val?.transaction?.id;
      this.shippingId = val?.id;
      this.collectPaymentModal = true;
    },
    transactionRoute(val) {
      if (!val) return;
      localStorage.setItem("billing_reciept", "recievable");
      this.$router.push({ name: "BCM_reciept", params: { id: val } });
    },

    invoiceRoute(val) {
      if (!val) return;
      this.$router.push({ name: "BCM_invoice", params: { id: val } });
    },

    sharelinkModalFunc(val) {
      this.payAmount = val?.transaction?.totalValue;
      this.email = val?.transaction?.id;
      this.paylink = val?.id;
      this.shareLinkModal = true;
    },
    statusBg(val) {
      let bg = "";
      switch (val) {
        case "pending":
          bg = "text-red-500";
          break;

        case "estimate":
          bg = "text-primary-yellow";
          break;

        default:
          bg = "text-teal-500";
          break;
      }
      return bg;
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
  min-width: 200px;
}
.actions div {
  @apply flex w-full py-2 px-2 items-center;
}
.icon {
  width: auto;
  padding-right: 5px;
}
</style>
